'use strict';

const { h } = require('phy');
const { hydrate } = require('@grpn/hydration');

const { redemptionHandler } = require('../../support/redemption-handler');
const { publish } = require('../../support/event-observer');

const carriageReturnCode = 13;

function CouponCardAction({ offerId, offerType = '' }) {
  const clickRedemptionHandler = () =>
    redemptionHandler({
      offerId,
      offerType,
    }).then(data => publish('@redemption', data));

  const keyUpRedemptionHandler = ev => {
    if (ev.keyCode === carriageReturnCode) {
      clickRedemptionHandler();
    }
  };

  return h('a.coupon-card-action', {
    onClick: clickRedemptionHandler,
    onKeyUp: keyUpRedemptionHandler,
    tabindex: 0,
    'data-bhc': `coupon:${offerId}`,
    'data-bhd': JSON.stringify({ type: offerType }),
    target: '_blank',
    rel: 'noopener',
  });
}

module.exports = hydrate('CouponCardAction', CouponCardAction);
